import { Link } from "react-router-dom";
import { newsList } from "@/mocks/news";
import { getItemById } from "@/hooks/useMediaQuery";

export default function NewsSection() {
  const [lead, ...rest] = newsList;
  const leadItem = getItemById(lead.relatedId);

  return (
    <section className="w-full bg-background-100/60 px-4 py-12 md:px-6 md:py-14">
      <div className="mb-6 flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
        <div>
          <p className="mb-2 flex items-center gap-2 font-label text-[11px] uppercase tracking-[0.22em] text-accent-600">
            <span className="h-px w-6 bg-accent-500" />
            Insiders
          </p>
          <h2 className="font-heading text-xl font-bold tracking-tight text-foreground-950 md:text-2xl">
            影视资讯
          </h2>
          <p className="mt-2 text-[13px] text-foreground-600">幕后、访谈与行业观察，带你了解剧集之外的影视动态</p>
        </div>
        <span className="flex w-fit items-center gap-1.5 rounded-full border border-background-300/70 bg-background-50 px-3 py-1.5 font-label text-[11px] text-foreground-600">
          <i className="ri-newspaper-line flex h-4 w-4 items-center justify-center text-accent-600" />
          每日更新
        </span>
      </div>

      <div className="grid grid-cols-1 gap-5 lg:grid-cols-5">
        <Link
          to={`/detail/${lead.relatedId}`}
          className="group relative col-span-1 overflow-hidden rounded-lg lg:col-span-2"
        >
          <div className="h-64 w-full overflow-hidden bg-background-200 lg:h-full lg:min-h-[340px]">
            <img
              src={lead.image}
              alt={lead.title}
              title={lead.title}
              className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
            />
          </div>
          <div className="absolute inset-0 bg-gradient-to-t from-primary-950 via-primary-950/50 to-transparent" />
          <div className="absolute inset-x-0 bottom-0 p-5">
            <span className="rounded-sm bg-accent-500 px-2 py-0.5 font-label text-[10px] font-semibold text-background-50">
              {lead.category}
            </span>
            <h3 className="mt-3 font-heading text-base font-bold leading-snug text-background-50 md:text-lg">
              {lead.title}
            </h3>
            <p className="mt-2 line-clamp-2 text-[12px] leading-relaxed text-background-50/70">{lead.summary}</p>
            <p className="mt-3 flex items-center gap-2 font-label text-[11px] text-background-50/55">
              <i className="ri-calendar-line flex h-3.5 w-3.5 items-center justify-center" />
              {lead.date}
              {leadItem ? <span>· {leadItem.title}</span> : null}
            </p>
          </div>
        </Link>

        <div className="col-span-1 flex flex-col divide-y divide-background-200 rounded-lg border border-background-200 bg-background-50 lg:col-span-3">
          {rest.map((news) => (
            <Link key={news.id} to={`/detail/${news.relatedId}`} className="group flex gap-4 p-4">
              <div className="h-[68px] w-[100px] shrink-0 overflow-hidden rounded-md bg-background-200">
                <img
                  src={news.image}
                  alt={news.title}
                  title={news.title}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="min-w-0 flex-1">
                <div className="flex items-center gap-2">
                  <span className="rounded-sm bg-secondary-100 px-1.5 py-0.5 font-label text-[10px] text-secondary-800">
                    {news.category}
                  </span>
                  <span className="font-label text-[10px] text-foreground-400">{news.date}</span>
                </div>
                <h3 className="mt-1.5 line-clamp-1-custom text-[13px] font-medium text-foreground-900 transition-colors group-hover:text-accent-600">
                  {news.title}
                </h3>
                <p className="mt-1 hidden line-clamp-1-custom text-[11px] text-foreground-500 sm:block">
                  {news.summary}
                </p>
              </div>
              <i className="ri-arrow-right-line mt-1 flex h-4 w-4 shrink-0 items-center justify-center text-foreground-300 transition-transform group-hover:translate-x-0.5 group-hover:text-accent-500" />
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}